function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 16"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  height: "16",
  rx: "2",
  width: "24"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "9",
  cy: "8",
  r: "5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "15",
  cy: "8",
  r: "5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 4a5 5 0 010 8 5 5 0 010-8z"
}))));